import angular from "angular";
import panel from "../services";

function resizeChatArea (panel) {

    return {
        restrict: 'A',
        scope: {
            dm: '=',
            i: '=',
        },
        link: (scope, element, attrs) => {
            let i = parseInt(attrs['number']);
            let j = attrs['length'];
            if (i === (j - 1)) {
                let area = $('#instantMessageBoard');
                // if (!attrs['fetchedOldMessages'])
                // area.animate({scrollTop: area[0].scrollHeight * 2}, 0.1);
            }

        }
    }
}

export default angular.module('directives.resizeChatArea', [panel]).directive('resizeChatArea', resizeChatArea).name;



// WEBPACK FOOTER //
// ./src/app/directives/resizeChatArea.js